import { Map } from 'immutable';
import { SET_SECTION } from './actionTypes';

export function setSection (dealType, realtyType) {
  return {
    type: SET_SECTION,
    payload: new Map({
      dealType,
      realtyType
    })
  };
}



// WEBPACK FOOTER //
// ./src/app/Dictionaries/actions.js